import output from "_src/engine/output";
import Animation from "_src/client/animation";

export default class CameraControl {
  constructor(object) {
    if (!object.isCamera) {
      output.error(output.DEVELOPERS_ERROR, "Can't attach control. Object is not a camera.");
      return;
    }

    this.enabled = true;
    this.object = object;
    this._animation = new Animation();
  }

  update(dt) {
    this._animation.update(dt);
  }

  setEnabled(enabled) {
    this.enabled = enabled;
  }

  zoom() {}
  startRotation() {}
  rotate() {}
  endRotation() {}
  pan() {}
}
